import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { ApiUrl } from '../services/apiUrl';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-terms-condtition',
  templateUrl: './terms-condtition.component.html',
  styleUrls: ['./terms-condtition.component.scss']
})
export class TermsCondtitionComponent implements OnInit {
  isSubmittedLocationForm: any;
  termsAndConditionForm: any;
  content: any;
  selectedLanguage: any = [
    { lable: "English", value: "en" },
    { lable: "Danish", value: "da" }
  ];

  // editorConfig: AngularEditorConfig;

  constructor(
    public service: ApiService,
    public toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.termsAndConditionForm = new FormGroup({
      language: new FormControl('en'),
      content: new FormControl('')
    })
    this.getTermsAndconditions()
  }
  getTermsAndconditions() {
    this.service.getRequest(`${ApiUrl.getTermsAndConditions}/${this.termsAndConditionForm.value.language}`).subscribe((res: any) => {
      this.termsAndConditionForm.patchValue({
        language: res.response.data.language? res.response.data.language:this.termsAndConditionForm.value.language,
        content: res.response.data.content
      })
    })
  }
  onEnter() {
    let body = {
      language: this.termsAndConditionForm.value.language,
      content: this.termsAndConditionForm.value.content
    }
    this.service.postRequest(ApiUrl.addTermsAndConditions, body).subscribe((res) => {

      this.toastr.success(res.response.message)
    })
  }
}
